// extracted by mini-css-extract-plugin
export var button = "_85-7";
export var buttonRow = "_85-6";
export var fadeIn = "_85-1";
export var gradient = "_85-0";
export var panel = "_85-2";
export var panelIn = "_85-3";
export var subtitle = "_85-5";
export var title = "_85-4";